import { AiMessage } from "@/src/data/allTypes";

function AiMessageCard({ message }: { message: AiMessage }) {
  return (
    <div className={`message ${message.role == "user" ? "sent" : ""}`}>
      <div className="messageBubble p20">
        <div contentEditable dangerouslySetInnerHTML={{ __html: message.content }} />
      </div>
    </div>
  );
}

export default AiMessageCard;
